import styled from '@emotion/styled'
import { EditorialType, FundingType } from '../../../lib'
import { tokens } from '@news-mono/design-tokens'
import { breakpoint, calcRem, metrics } from '../../../../../__styling'

export const StyledEditorialLabel = styled.div({
    paddingBottom: calcRem(8),
    paddingLeft: metrics.thenightly.margins.md,
    paddingRight: metrics.thenightly.margins.md,

    [breakpoint('sm')]: {
        paddingLeft: 0,
        paddingRight: 0,
    },
})

export const StyledEditorialLabelText = styled.span<{
    type: EditorialType | FundingType
}>(({ theme, type }) => ({
    textTransform: 'uppercase',
    font: theme.fonts.heading,
    fontSize: calcRem(18),
    fontWeight: 600,
    lineHeight: calcRem(24),
    letterSpacing: calcRem(-0.36),
    color:
        type === EditorialType.Breaking ||
        type === EditorialType.Live ||
        type === EditorialType.Exclusive
            ? tokens.thenightly.colors.palette.utility.error.default
            : undefined,
}))
